module.exports = __webpack_public_path__ + "static/media/sq-choose-theme.35ee6b71.mp4";